"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setHocDisplayName(Wrapper, Wrapped) {
    Wrapper.displayName = Wrapper.name + "(" + (Wrapped.displayName || Wrapped.name) + ")";
}
exports.default = setHocDisplayName;
